@if (assignee; as assigneeData) {
  @switch (assigneeData.assignmentType) {
    @case ('UserTaskAssignmentStrategy') {
      <div class="flex items-center space-x-2">
        {{ assigneeData.displayName }}
      </div>
    }
    @case ('TourTaskAssignmentStrategy') {
      <div class="flex items-center space-x-2">
        <a [routerLink]="['/tour-planner/detail/' + assigneeData?.id]" 
           class="jump" 
           (mouseenter)="onTourHover($event, assigneeData?.id)"
           (mouseleave)="onTourLeave()">
          <span class="hover:underline cursor-pointer">{{ assigneeData.displayName }}</span>
        </a>
      </div>
      <nx-tour-details-overlay 
        #tourOverlay
        [tourDetails]="tourDetails()"
        [isLoading]="isLoadingTourDetails()">
      </nx-tour-details-overlay>
    }
    @case ('LocationTaskAssignmentStrategy') {
      <div class="flex items-center space-x-2">
        {{ assigneeData.displayName }}
      </div>
    }
    @default {
      <div class="flex items-center space-x-2">
        <span class="text-gray-500">{{ assigneeData.displayName || '-' }}</span>
      </div>
    }
  }
} @else {
  <div class="flex items-center space-x-2">
    <span class="text-gray-500">-</span>
  </div>
}
